import { createStore } from "@tredespace/ui/lib";

export type SelectedLeg = Readonly<{
  key: string;
  x: number;
  z: number;
  segments: readonly number[];
  /** Total height in metres. */
  height: number;
}>;

export type SelectionState = Readonly<{ leg: SelectedLeg | null }>;

export const selectionState = createStore<SelectionState>({ leg: null });
